// extracted by mini-css-extract-plugin
module.exports = {"total":"payment_total__WB6oe","header":"payment_header__BZipC","headerRoot":"payment_headerRoot__3spXm"};